import React, {useState} from 'react';
import {Helmet} from 'react-helmet';
import {compose, graphql} from 'react-apollo';
import gql from 'graphql-tag';

import {Card, Loading, Button} from 'ui-kit';
import {SettingsSection} from '../SettingsSection';

import {NewStaffMemberModal, UpdatePasswordForm} from './components';
import * as styles from './Accounts.module.css';

function Accounts({data}) {
  const [newStaffModalVisible, setNewStaffModalVisible] = useState(false);

  if (data.loading) {
    return <Loading />;
  }

  if (data.error) {
    console.error(data.error);
    return <p>An unexpected error occurred.</p>;
  }

  const {
    id,
    practice: {staffMembers},
  } = data.me;

  return (
    <>
      <Helmet title="Accounts" />

      <SettingsSection
        title="Staff members"
        description="You can create a login for each member of your staff to use to access membership data."
      >
        <NewStaffMemberModal
          show={newStaffModalVisible}
          onDismiss={() => setNewStaffModalVisible(false)}
          onSubmit={() => {
            data.refetch();
            setNewStaffModalVisible(false);
          }}
        />

        <Card>
          <div className={styles.StaffMembersContainer}>
            {staffMembers.map(staffMember => {
              const content =
                staffMember.firstName == null &&
                staffMember.lastName == null ? (
                  <p>
                    {staffMember.email}
                    {staffMember.id === id ? ' (You)' : null}
                  </p>
                ) : (
                  <p>
                    {staffMember.firstName} {staffMember.lastName}
                    {staffMember.id === id ? ' (You)' : null} <br />
                    <small>{staffMember.email}</small>
                  </p>
                );

              return (
                <div key={staffMember.id} className={styles.StaffMember}>
                  {content}
                </div>
              );
            })}
          </div>

          <Button onClick={() => setNewStaffModalVisible(true)}>
            Add staff member
          </Button>
        </Card>
      </SettingsSection>

      <SettingsSection title="Update your password">
        <Card>
          <UpdatePasswordForm />
        </Card>
      </SettingsSection>
    </>
  );
}

export default compose(
  graphql(
    gql`
      query StaffQuery {
        me {
          ... on StaffMember {
            id
            practice {
              id
              staffMembers {
                id
                email
                firstName
                lastName
              }
            }
          }
        }
      }
    `,
  ),
)(Accounts);
